
import { Link } from 'react-router-dom';

interface Slot {
  id: string;
  date: string;
  time_slot: string;
  is_available: boolean;
}

interface UpcomingSlotsProps {
  slots: Slot[];
}

export default function UpcomingSlots({ slots }: UpcomingSlotsProps) {
  const today = new Date().toISOString().split('T')[0];
  const upcoming = slots
    .filter((s) => s.date >= today && s.is_available)
    .sort((a, b) => a.date.localeCompare(b.date) || a.time_slot.localeCompare(b.time_slot))
    .slice(0, 8);

  const formatDate = (date: string) =>
    new Date(date + 'T00:00:00').toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });

  const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':');
    const h = parseInt(hours, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    return `${h % 12 || 12}:${minutes} ${ampm}`;
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-base font-bold text-slate-900">Upcoming Availability</h3>
        <Link
          to="/admin?tab=availability"
          className="text-xs text-emerald-600 font-medium hover:text-emerald-700 transition-colors cursor-pointer"
        >
          Manage
        </Link>
      </div>

      {upcoming.length === 0 ? (
        <div className="text-center py-10">
          <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
            <i className="ri-calendar-line text-xl text-gray-400"></i>
          </div>
          <p className="text-sm text-gray-500">No upcoming slots</p>
          <Link
            to="/admin?tab=availability"
            className="text-xs text-emerald-600 font-medium mt-2 inline-block cursor-pointer"
          >
            Add availability
          </Link>
        </div>
      ) : (
        <div className="space-y-2">
          {upcoming.map((slot) => (
            <div
              key={slot.id}
              className="flex items-center justify-between px-3 py-2.5 rounded-xl bg-gray-50"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center">
                  <i className="ri-time-line text-sm text-emerald-600"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-900">{formatTime(slot.time_slot)}</p>
                  <p className="text-[11px] text-gray-500">{formatDate(slot.date)}</p>
                </div>
              </div>
              <span className="text-[10px] font-semibold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full">
                Open
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
